import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '../components/Layout/AppLayout.vue'
import AdminLayout from '../components/AdminLayout.vue'
import Login from '../views/Login.vue'
import Welcome from '../views/Welcome.vue'
import Dashboard from '../views/DashboardNew.vue'
import ProductManagement from '../views/ProductManagement.vue'
import DeviceManagement from '../views/DeviceManagement.vue'
import AlarmCenter from '../views/AlarmCenter.vue'
import FamilyManagement from '../views/FamilyManagement.vue'
import HealthAnalysis from '../views/HealthAnalysis.vue'
import LocationTracking from '../views/LocationTracking.vue'

// 管理员页面
import AdminLogin from '../views/AdminLogin.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import AdminFamilyManagement from '../views/AdminFamilyManagement.vue'
import AdminDeviceManagement from '../views/AdminDeviceManagement.vue'
import DeviceDetail from '../views/DeviceDetail.vue'

const routes = [
  {
    path: '/',
    redirect: '/welcome'
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // 管理员登录页面
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  // 管理员页面（使用AdminLayout组件布局）
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAdminAuth: true },
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard
      },
      {
        path: 'families',
        name: 'AdminFamilyManagement',
        component: AdminFamilyManagement
      },
      {
        path: 'families/:id',
        name: 'AdminFamilyDetail',
        component: () => import('../views/AdminFamilyDetail.vue'),
        beforeEnter: (to, from, next) => {
          const id = to.params.id
          console.log('AdminFamilyDetail route guard - ID:', id)
          
          // 确保ID不是已知的路由路径名称
          const invalidIds = ['dashboard', 'devices', 'products', 'device-types', 'families', 'detail']
          if (invalidIds.includes(id)) {
            console.warn('Invalid family ID detected in route:', id)
            next('/admin/families')
            return
          }
          
          // 验证是否为UUID格式
          const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
          if (!uuidRegex.test(id)) {
            console.warn('Invalid UUID format for family ID:', id)
            next('/admin/families')
            return
          }
          
          console.log('Valid family ID, proceeding to detail page')
          next()
        }
      },
      {
        path: 'devices',
        name: 'AdminDeviceManagement',
        component: AdminDeviceManagement
      },
      {
        path: 'devices/:id',
        name: 'DeviceDetail',
        component: DeviceDetail
      },
      {
        path: 'products',
        name: 'AdminProductManagement',
        component: ProductManagement
      },
      {
        path: 'products/:id',
        name: 'ProductDetail',
        component: () => import('../views/ProductDetail.vue')
      },
      {
        path: 'device-types',
        name: 'AdminDeviceTypeManagement',
        component: () => import('../views/DeviceTypeManagement.vue')
      }
    ]
  },
  {
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'products',
        name: 'ProductManagement',
        component: ProductManagement
      },
      {
        path: 'devices',
        name: 'DeviceManagement',
        component: DeviceManagement
      },
      {
        path: 'devices/:id',
        name: 'UserDeviceDetail',
        component: DeviceDetail
      },
      {
        path: 'alarms',
        name: 'AlarmCenter',
        component: AlarmCenter
      },
      {
        path: 'family',
        name: 'FamilyManagement',
        component: FamilyManagement
      },
      {
        path: 'family/:id',
        name: 'FamilyDetail',
        component: () => import('../views/FamilyDetail.vue')
      },
      {
        path: 'health',
        name: 'HealthAnalysis',
        component: HealthAnalysis
      },
      {
        path: 'location',
        name: 'LocationTracking',
        component: LocationTracking
      },
      {
        path: 'alarm-simulator',
        name: 'AlarmSimulator',
        component: () => import('@/views/AlarmSimulator.vue')
      },
      {
        path: 'third-party-guide',
        name: 'ThirdPartyGuide',
        component: () => import('@/views/ThirdPartyGuide.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 管理员页面认证
  if (to.meta.requiresAdminAuth) {
    const adminUser = localStorage.getItem('adminUser')
    const userRole = localStorage.getItem('userRole')
    
    if (!adminUser || userRole !== 'admin') {
      // 清理无效的管理员登录信息
      localStorage.removeItem('adminUser')
      localStorage.removeItem('userRole')
      next('/admin/login')
    } else {
      next()
    }
  }
  // 普通用户页面认证
  else if (to.meta.requiresAuth) {
    const user = localStorage.getItem('user')
    const family = localStorage.getItem('family')
    const token = localStorage.getItem('token')
    
    if (!user || !family || !token) {
      // 清理无效的登录信息
      localStorage.removeItem('user')
      localStorage.removeItem('family')
      localStorage.removeItem('token')
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router